import getEnv from "@/utilities/env.js";

// Sends best-effort metadata about the web client (version, platform) to the
// backend so it can be recorded for troubleshooting. Intended to fire once per
// login. Never throws – diagnostics must not block or break the app.
export default async function reportClientMetadata() {
  const token = localStorage.getItem("token");
  if (!token) return;

  try {
    await fetch(`${getEnv("VUE_APP_SERVER_URL")}/api/client-metadata`, {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        authorization: `Bearer ${token}`
      },
      body: JSON.stringify({
        client_version: getEnv("VUE_APP_VERSION") || "",
        platform: navigator.platform
      })
    });
  } catch (e) {
    // best-effort only
  }
}
